import { FC } from "react";
import { ProductFeature } from "../../../domain/models/ProductFeature";
import { ProductFeatureFields } from "../../../domain/enums/productFeatureFieldsEnum";
import AddRowsSVG from "../../../components/shared/svg/AddRowsSVG";

interface ProductFeatureRowProps {
    productFeature: ProductFeature;
    updateHandler: (productFeature: ProductFeature) => void;
}

const ProductFeatureTableRow: FC<ProductFeatureRowProps> = (props) => {
    const updateProductFeatureHandler = () => {
        props.updateHandler(props.productFeature);
    };

    return (
        <tr className="bg-light-bg-200 dark:bg-dark-bg-800 border-b hover:bg-gray-200 dark:hover:bg-dark-bg-800 border-light-border-200 dark:border-dark-border-200">
            {Object.values(ProductFeatureFields).map((value, index) => {
                return (
                    <td
                        key={`td-productFeature-table-${index}`}
                        className={`px-2 py-1 truncate ${
                            index === 0 ? "hover:whitespace-normal hover:overflow-visible hover:text-clip" : ""
                        } text-center max-w-[95px] border-light-border-200 dark:border-dark-border-200 border`}
                    >
                        {props.productFeature[value]}
                    </td>
                );
            })}
            {/* <td className="px-2 py-1 border-light-border-200 dark:border-dark-border-200 border text-center">
                <button
                    onClick={updateProductFeatureHandler}
                    className="flex items-center justify-center rounded-[8px] bg-[#5CD685E5] hover:opacity-80 w-[28px] h-[28px] mx-auto"
                    title="Редагувати"
                >
                    <AddRowsSVG className="w-[16px] h-[16px] fill-light-bg-200 dark:fill-dark-bg-800" />
                </button>
            </td> */}
        </tr>
    );
};

export default ProductFeatureTableRow;
